export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_CARRERAS_ALUMNO = "SET_CARRERAS_ALUMNO";
export const SET_ERRORES = "SET_ERRORES";
export const SET_SUCCESS = "SET_SUCCESS";
export const SET_INFO = "SET_INFO";
